'use strict';

module.exports = {
	statusAttributeName: 'progress',
	statusConfigAttr: 'progress-statuses'
};
